import { render, staticRenderFns } from "./Pagos.vue?vue&type=template&id=e585f788&scoped=true&"
import script from "./Pagos.vue?vue&type=script&lang=ts&"
export * from "./Pagos.vue?vue&type=script&lang=ts&"
import style0 from "./Pagos.vue?vue&type=style&index=0&id=e585f788&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e585f788",
  null
  
)

export default component.exports